import {selectPendingShootingActions, selectUnits} from "../../../redux/reducers/sharedStateReducer/selectors";
import {getPlayerUnits} from "../../players/getPlayerUnits";
import {checkIfUnitCanMove} from "./checkIfUnitCanMove";
import {checkIfUnitCanUseAbility} from "./checkIfUnitCanUseAbility";
import {checkIfUnitCanShoot} from "./checkIfUnitCanShoot";
import {checkIfUnitCanManeuver} from "./checkIfUnitCanManeuver";
import {
  checkIfUnitAbilityProcessed,
  checkIfUnitManeuverProcessed,
  checkIfUnitMovementProcessed,
  checkIfUnitShootingProcessed
} from "./checkIfUnitProcessed";

const NO_PENDING_SHOOTING_ACTIONS = [];

// Отряды игрока на этапе войны: обработанные, способные действовать и
// остальные (idleIds) — не обработаны и действовать не могут
const splitPlayerUnits = (state, player, checkIfProcessed, checkIfCanAct) => {
  const processedIds = [];
  const actionableIds = [];
  const idleIds = [];
  getPlayerUnits(player, selectUnits(state) || []).forEach((unit) => {
    if (checkIfProcessed(state, unit)) {
      processedIds.push(unit.id);
    } else if (checkIfCanAct(state, unit, player)) {
      actionableIds.push(unit.id);
    } else {
      idleIds.push(unit.id);
    }
  });
  return {processedIds, actionableIds, idleIds};
};

// В перемещении дело — каждый отряд игрока, даже если идти ему некуда:
// перемещаться по своим свойствам может любой отряд (spec phase-progress,
// «Дела перемещения»). Такой отряд входит в S, но не может действовать
export const getMovementUnits = (state, player) => splitPlayerUnits(
  state, player, checkIfUnitMovementProcessed, checkIfUnitCanMove
);

export const getAbilityUnits = (state, player) => splitPlayerUnits(
  state, player, checkIfUnitAbilityProcessed, checkIfUnitCanUseAbility
);

// Заявленные выстрелы этапа учитываются в целях: у второго стрелка может не
// остаться цели после выстрела первого
export const getShootingUnits = (state, player) => {
  const pendingShootingActions = selectPendingShootingActions(state) || NO_PENDING_SHOOTING_ACTIONS;
  return splitPlayerUnits(
    state, player, checkIfUnitShootingProcessed,
    (currentState, unit) => checkIfUnitCanShoot(currentState, unit, player, {pendingShootingActions})
  );
};

export const getManeuverUnits = (state, player) => splitPlayerUnits(
  state, player, checkIfUnitManeuverProcessed, checkIfUnitCanManeuver
);
